<div>
  <ng-container *ngIf="lspInfo$ | async as lspInfo">
    <div *ngIf="!!lspInfo.isEnabled" class="warning-banner">
      <span>
        <strong>
          {{ lspInfo.dateSourcesEnabled | glxyDate: DateFormat.medium }}
        </strong>
        {{ 'CUSTOMIZE_PARTNER.LISTING_SOURCES.LSP_TURNED_ON' | translate }}
        <mat-icon
          inline
          matTooltip="{{
            'CUSTOMIZE_PARTNER.LISTING_SOURCES.LSP_TURNED_ON_TOOLTIP'
              | translate
          }}"
        >
          info
        </mat-icon>
      </span>
    </div>
  </ng-container>

  <ng-container *ngFor="let provider of lspProviders$ | async">
    <div *ngIf="provider === 1" class="lsp-source-service-provider">
      <img
        src="https://www.cdnstyles.com/static/images/listing-sync-pro/lsp-0.png"
      />
      <span>Listing Sync Pro</span>
    </div>
    <div *ngIf="provider === 2" class="lsp-source-service-provider">
      <img
        src="https://www.cdnstyles.com/static/images/listing-sync-pro/lsp-1.svg"
      />
      <span>Listing Sync Pro powered by Yext</span>
    </div>
  </ng-container>
</div>

<p>{{ 'CUSTOMIZE_PARTNER.LISTING_SOURCES.CACHE_WARNING' | translate }}</p>

<v-form [formOptions]="lsFormOptions" fieldWidth="100%"></v-form>
